import type { QueryClient } from "@tanstack/react-query";
import { ClassesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi, createOpenApiConfiguration } from "@/lib/utils";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

export async function prefetchClass(
  queryClient: QueryClient,
  classId: number,
  accessToken?: string,
  tenantId: number = resolveEffectiveTenantNumber(),
) {
  const service = accessToken
    ? createAuthenticatedApi(ClassesApi, accessToken)
    : new ClassesApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Class, classId],
    queryFn: () =>
      service.getClassById({
        id: classId,
        xTenantID: tenantId,
      }),
  });

  return queryClient;
}
